export default "__VITE_ASSET__cacee34a__"